export const MESSAGE_MAX_LENGTH = 1000;

export const INPUT_TYPE = {
  TYPED: 'typed',
  VOICE: 'voice',
};

export const AIGC_TYPE = {
  TEXT: 'text',
};

export const SPEECH_TO_TEXT_CHANGE = 'SPEECH_TO_TEXT_CHANGE';
export const SPEECH_TO_TEXT_RESET = 'SPEECH_TO_TEXT_RESET';
